import { FourTermsAssignmentCtrl } from './four-terms-assignment.controller';

export const FourTermsAssignment = {
  controller: FourTermsAssignmentCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./four-terms-assignment.html'),
};
